import { useAppSelector } from '../../utils/agent.store'

const CaseIdBreadCrumbs = () => {
  const caseInfo = useAppSelector((state) => state?.workflowData?.caseDetails)
  const currentUrl = window.location.href

  return currentUrl.endsWith('/workflow')
    ? 'Workflow Error'
    : caseInfo?.caseId ?? ''
}

export default CaseIdBreadCrumbs
